module.exports = __webpack_public_path__ + "img/retailer_logo.ec800f12.png";